export class WarehouseUtil {

  public static getDescription(warehouseCode?: string) {

    const key = (warehouseCode || "").toUpperCase();

    switch (key)
    {
        case "RP":
        case "RPI":
        case "0R":
            return "Grand Rapids";
        case "YO":
            return "Easton";
        case "ON":
            return "Ontario";
        case "IN":
            return "Indianapolis";
        case "MCF":
            return "Total MCF Quantity";
        case "AL":
            return "Puurs";
        case "SI":
            return "Singapore";
        case "JP":
            return "Japan";
        case "TX":
            return "Dallas";
        default:
            return warehouseCode || "";
    }
  }
}
